export const GlobalConfigs = {
	//FIXME: Change before pushing
	UseAuth: true,
};
